import React, { useState, useEffect, useCallback } from 'react'
import { Container, Page } from 'components'

import { ThemeProvider, createTheme } from '@material-ui/core'
import { Grid, Hidden } from '@material-ui/core'
import useAuth from 'hooks/useAuth'
import checkoutTheme from 'theme/checkoutTheme'
import { CheckoutPayment, EditPage } from './components'

import themeSuperfin from 'theme'

import constants from 'constants/index'

import useSnackbar from 'hooks/useSnackbar'

import * as service from 'service'

import { CompanyLogo, ProductDetails } from 'componentsCheckout'

const PreviewCheckoutMain = ({ match }) => {
  const type = match.params.type
  const token = match.params.token
  const { user } = useAuth()
  const defaultComponents = constants?.defaultInputsCheckout
  const [components, setComponents] = useState(defaultComponents)
  const order = {
    payment: {
      code: '2',
      value: 22,
      products: [
        {
          name: 'Produto A',
          description: 'O produto tem determinada características',
          price: '22.00',
          quantity: 1,
        },
      ],
      status: 'NOT_PAID',
      description: 'Produto Avulso 1',
      expirationDate: '2024-03-01',
    },
    seller: {
      email: null,
      name: 'Eduardo Batista',
      phone: null,
      token: 'ad3d9e7cd5f08c24adcf220089923783',
    },
  }

  const [step, setStep] = useState(1)
  const [customer, setCustomer] = useState({})
  const [theme, setTheme] = useState(null)
  const snackbar = useSnackbar()

  const changeColor = (value) => {
    setTheme((prevTheme) => {
      let newTheme = { ...prevTheme }
      for (const category in value) {
        if (!newTheme[category]) {
          newTheme[category] = {}
        }
        for (const field in value[category]) {
          newTheme[category][field] = value[category][field]
        }
      }

      postTheme(components?.urlImage)
      return newTheme
    })
  }

  const changeInput = (value) => {
    setComponents(value)
    postTheme(value?.urlImage, value?.settings?.inputs)
  }

  const postTheme = async (urlImage, settings) => {
    let newTheme2 = {
      ...components,
      urlImage: urlImage,
      settings: {
        inputs: settings || components?.settings?.inputs,
        theme: theme,
      },
    }

    try {
      await service.intermediador.accountCustomizations.create({
        tag: 'theme',
        data: JSON.stringify(newTheme2),
      })
      snackbar.open({
        variant: 'success',
        message: 'Personalização aplicada com sucesso!',
      })
    } catch (error) {
      snackbar.open({
        variant: 'error',
        message: 'Erro ao aplicar a personalização',
      })
      return null
    }
  }

  const getTheme = useCallback(async () => {
    try {
      const response = await service.intermediador.accountCustomizations.show(
        'theme',
        user?.account?.id,
      )

      const themeData = JSON.parse(response?.data.accountCustomization?.data)
      const newThemeWithSpacing = {
        ...themeData,
        settings: {
          ...themeData.settings,
          theme: {
            ...themeData.settings.theme,
            spacing: checkoutTheme?.spacing,
          },
        },
      }

      setTheme(createTheme(newThemeWithSpacing?.settings?.theme))
      setComponents(newThemeWithSpacing)
    } catch (error) {
      setTheme(createTheme(checkoutTheme))
      return null
    }
  }, [user])

  useEffect(() => {
    const fetchData = async () => {
      if (user && theme === null) {
        await getTheme()
      }
    }
    fetchData()
  }, [theme, user, getTheme])

  return (
    <div style={{ backgroundColor: theme?.palette?.background?.default }}>
      <ThemeProvider theme={themeSuperfin}>
        <EditPage
          changeColor={changeColor}
          changeInput={changeInput}
          customPalette={theme}
          partnerGroup={order?.seller?.partnerGroup}
          sellerData={order?.seller}
          components={components}
        />
      </ThemeProvider>
      {user && (
        <Container maxWidth="md">
          <>
            {theme && (
              <ThemeProvider theme={theme}>
                <Page title="Pagamento" style={{ minHeight: '104vh' }}>
                  <Grid container>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <CompanyLogo
                        partnerGroup={order?.seller?.partnerGroup}
                        sellerData={order?.seller}
                        urlImage={components?.urlImage}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={7}>
                      <CheckoutPayment
                        type={type}
                        token={token}
                        order={order}
                        customer={customer}
                        setCustomer={setCustomer}
                        step={step}
                        setStep={setStep}
                        loading={false}
                        components={components}
                      />
                    </Grid>
                    <Hidden smDown>
                      <Grid item xs={6} md={1} sm={12} lg={1}></Grid>
                    </Hidden>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                      <ProductDetails
                        order={order?.payment}
                        type={type}
                        match={match}
                      />
                    </Grid>
                  </Grid>
                </Page>
              </ThemeProvider>
            )}
          </>
        </Container>
      )}
    </div>
  )
}

export default PreviewCheckoutMain
